module.exports = __webpack_public_path__ + "static/img/No1.6360f561.png";